// Create a useHistory hook to manage the windows.history object
interface HistoryHook {
    length: number;
    state: any;
    push: (url: string) => void;
    replace: (url: string) => void;
}

export const useHistory = () => {
    if (typeof window === 'undefined') { return {} as HistoryHook; }

    // Implement the push method
    const push = (url: string) => window.history.pushState({}, '', url);

    // Implement the replace method
    const replace = (url: string) => window.history.replaceState({}, '', url);

    // Return the history object
    return {
        length: window.history.length,
        state: window.history.state,
        push,
        replace
    };
};